import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import HttpClientXml from "../utils/HttpClientXml";
import HomeService from "../Services/HomeService";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function ManageReels() {
  const [reels, setReels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reelID, setReelID] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [cities, setCities] = useState([]);
  const [editData, setEditData] = useState({
    city: "",
    thumbnail: "",
    video: "",
    description: "",
  });

  // Function to show description in popup
  const showDescriptionPopup = (description, title = "Description") => {
    Swal.fire({
      title: title,
      html: `
        <div style="text-align: left; max-height: 400px; overflow-y: auto; padding: 10px;">
          <p style="white-space: pre-wrap; word-wrap: break-word;">${
            description || "No description available"
          }</p>
        </div>
      `,
      showCloseButton: true,
      showConfirmButton: false,
      width: "600px",
      customClass: {
        popup: "description-popup",
      },
    });
  };

  // Function to get city name from reel data
  const getCityName = (reel) => {
    if (reel.cityData && reel.cityData.name) {
      return reel.cityData.name;
    }
    if (reel.city && typeof reel.city === "object" && reel.city.name) {
      return reel.city.name;
    }
    // Find city from cities array if city is just an ID
    if (reel.city && typeof reel.city === "string") {
      const city = cities.find((c) => c._id === reel.city);
      return city ? city.name : "Unknown City";
    }
    return "Unknown City";
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      // width: "80px",
    },
    {
      name: "City",
      selector: (row) => getCityName(row),
      sortable: true,
      cell: (row) => (
        <div className="d-flex align-items-center">
          <span className="badge bg-secondary" style={{ fontSize: "12px" }}>
            {getCityName(row)}
          </span>
        </div>
      ),
      // width: "150px",
    },
    {
      name: "Description",
      cell: (row) => {
        const description = row.description || "";
        const shortDescription =
          description.length > 10
            ? `${description.substring(0, 10)}...`
            : description;

        return (
          <div className="d-flex align-items-center">
            <span className="me-2" style={{ minWidth: "50px" }}>
              {shortDescription || (
                <span className="text-muted">No description</span>
              )}
            </span>
            {description.length > 10 && (
              <button
                type="button"
                className="btn btn-sm p-0"
                onClick={() =>
                  showDescriptionPopup(description, "Reel Description")
                }
                title="View full description"
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#007bff",
                  fontSize: "16px",
                }}
              >
                <i className="fa-solid fa-eye"></i>
              </button>
            )}
          </div>
        );
      },
      sortable: true,
      // sortFunction: (rowA, rowB) => {
      //   const descA = rowA.description || "";
      //   const descB = rowB.description || "";
      //   return descA.localeCompare(descB);
      // },
      // width: "150px",
    },
    {
      name: "Thumbnail",
      cell: (row) => (
        <img
          src={row.thumbnail || "/placeholder-image.png"}
          alt="Thumbnail"
          width="60"
          height="60"
          style={{
            borderRadius: "8px",
            objectFit: "cover",
            border: "1px solid #dee2e6",
          }}
        />
      ),
      center: true,
      // width: "100px",
    },
    {
      name: "Video",
      cell: (row) => (
        <div style={{ position: "relative" }}>
          <video
            width="80"
            height="60"
            style={{
              borderRadius: "8px",
              objectFit: "cover",
              border: "1px solid #dee2e6",
            }}
            preload="metadata"
          >
            <source src={row.video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "rgba(0,0,0,0.7)",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => window.open(row.video, "_blank")}
          >
            <i
              className="fa-solid fa-play"
              style={{ color: "white", fontSize: "12px", marginLeft: "2px" }}
            ></i>
          </div>
        </div>
      ),
      center: true,
      // width: "100px",
    },
    // {
    //   name: "Status",
    //   cell: (row) => (
    //     <span
    //       className={`badge ${
    //         row.status
    //           ? "bg-success"
    //           : row.isDeleted
    //           ? "bg-danger"
    //           : "bg-warning"
    //       }`}
    //       style={{ fontSize: "12px" }}
    //     >
    //       {row.status ? "Active" : row.isDeleted ? "Deleted" : "Inactive"}
    //     </span>
    //   ),
    //   center: true,
    //   width: "100px",
    // },
    {
      name: "Created Date",
      selector: (row) =>
        new Date(
          row.createdAt || row.createdOn || row.updatedAt
        ).toLocaleDateString(),
      sortable: true,
      center: true,
      // width: "120px",
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <button
            title="Edit"
            onClick={() => handleEdit(row)}
            className="btn btn-sm me-2"
            style={{
              background: "transparent",
              border: "none",
              color: "rgb(133, 218, 79)",
            }}
          >
            <i className="fa-solid fa-pen-to-square fs-5"></i>
          </button>
          <button
            title="Delete"
            onClick={() => handleDelete(row._id)}
            className="btn btn-sm"
            style={{
              background: "transparent",
              border: "none",
              color: "#dc3545",
            }}
          >
            <i className="fa-solid fa-trash-can fs-5"></i>
          </button>
        </div>
      ),
      center: true,
      // width: "120px",
    },
  ];

  const fetchAllReels = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getReel();
      console.log("Reels data:", res.data);
      setReels(res.data);
    } catch (error) {
      console.error("Error fetching reels:", error);
      toast.error("Failed to load reels!");
    } finally {
      setLoading(false);
    }
  };

  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.data) {
        setCities(res.data);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
      toast.error("Failed to fetch cities");
    }
  };

  useEffect(() => {
    fetchAllReels();
    fetchCities();
  }, []);

  const handleEdit = (row) => {
    setIsEdit(true);
    setEditData({
      city: row.city || (row.cityData ? row.cityData._id : ""),
      thumbnail: row.thumbnail || "",
      video: row.video || "",
      description: row.description || "",
    });
    setReelID(row._id);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Reel?",
      text: "Are you sure you want to delete this reel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        await HomeService.deleteReel(id);
        Swal.fire("Deleted!", "Reel has been deleted.", "success");
        fetchAllReels();
      } catch (error) {
        Swal.fire("Error!", "Failed to delete reel.", "error");
      }
    }
  };

  const handleThumbnailUpload = async (e) => {
    if (!e.target.files[0]) return;

    const data = new FormData();
    data.append("image", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.image) {
        setEditData({ ...editData, thumbnail: res.image });
        toast.success("Thumbnail uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload thumbnail.");
      console.error("Error uploading thumbnail:", error);
    }
  };

  const handleVideoUpload = async (e) => {
    if (!e.target.files[0]) return;

    const data = new FormData();
    data.append("image", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.image) {
        setEditData({ ...editData, video: res.image });
        toast.success("Video uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload video.");
      console.error("Error uploading video:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!editData.city) {
      toast.error("Please select a city.");
      return;
    }

    if (!editData.description.trim()) {
      toast.error("Please enter a description for the reel.");
      return;
    }

    try {
      // Prepare update data
      const data = {
        city: editData.city,
        ...(editData.thumbnail && { thumbnail: editData.thumbnail }),
        ...(editData.video && { video: editData.video }),
        description: editData.description,
      };

      console.log("Updating reel with data:", data);

      const res = await HomeService.updateReel(reelID, data);

      if (res?.status) {
        toast.success("Reel updated successfully!");
        setIsEdit(false);
        setEditData({ city: "", thumbnail: "", video: "", description: "" });
        fetchAllReels();
      } else {
        toast.error(res?.message || "Failed to update reel.");
      }
    } catch (error) {
      toast.error("Failed to update reel.");
      console.error("Error updating reel:", error);
    }
  };

  const handleCancel = () => {
    setIsEdit(false);
    setEditData({ city: "", thumbnail: "", video: "", description: "" });
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          {isEdit ? (
            <section className="chartBox_area">
              <div className="card">
                <div className="card-header">
                  <h4 className="mb-0">Edit Reel</h4>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      {/* City Selection */}
                      <div className="col-md-6 mt-3">
                        <label>
                          City<span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="city"
                          value={editData.city}
                          onChange={(e) =>
                            setEditData({ ...editData, city: e.target.value })
                          }
                          required
                        >
                          <option value="" disabled>
                            ---Select City---
                          </option>
                          {cities.map((city) => (
                            <option key={city._id} value={city._id}>
                              {city.name}
                            </option>
                          ))}
                        </select>
                        <small className="text-muted">
                          Select the city for this reel
                        </small>
                      </div>

                      {/* Thumbnail Upload Section */}
                      <div className="col-md-6 mt-3">
                        <label>
                          Thumbnail
                          <span className="text-muted"> (optional)</span>
                        </label>
                        {editData.thumbnail && (
                          <div className="mt-2 mb-2">
                            <img
                              src={editData.thumbnail}
                              alt="Thumbnail Preview"
                              style={{
                                maxHeight: "150px",
                                maxWidth: "100%",
                                borderRadius: "8px",
                                border: "2px solid #dee2e6",
                              }}
                            />
                          </div>
                        )}
                        <input
                          type="file"
                          className="form-control"
                          onChange={handleThumbnailUpload}
                          accept="image/*"
                        />
                        <small className="text-muted">
                          Upload new thumbnail (optional)
                        </small>
                      </div>

                      {/* Video Upload Section */}
                      <div className="col-md-6 mt-3">
                        <label>
                          Video
                          <span className="text-muted"> (optional)</span>
                        </label>
                        {editData.video && (
                          <div className="mt-2 mb-2">
                            <video
                              controls
                              style={{
                                maxHeight: "150px",
                                maxWidth: "100%",
                                borderRadius: "8px",
                                border: "2px solid #dee2e6",
                              }}
                            >
                              <source src={editData.video} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        )}
                        <input
                          type="file"
                          className="form-control"
                          onChange={handleVideoUpload}
                          accept="video/*"
                        />
                        <small className="text-muted">
                          Upload new video (optional)
                        </small>
                      </div>

                      {/* Description Textarea */}
                      <div className="col-md-6 mt-3">
                        <label htmlFor="description">
                          Description<span className="text-danger">*</span>
                        </label>
                        <textarea
                          id="description"
                          className="form-control"
                          value={editData?.description || ""}
                          onChange={(e) =>
                            setEditData((prev) => ({
                              ...prev,
                              description: e.target.value,
                            }))
                          }
                          rows="4"
                          placeholder="Enter reel description..."
                          required
                          style={{ height: "172px" }}
                        ></textarea>
                        <small className="text-muted">
                          Enter a description for the reel
                        </small>
                      </div>
                    </div>

                    <div className="mt-4 pt-3 border-top">
                      <button
                        type="submit"
                        className="btn btn-primary me-3"
                        style={{
                          background: "rgb(133, 218, 79)",
                          border: "none",
                          padding: "10px 25px",
                          fontWeight: "500",
                        }}
                      >
                        <i className="fa-solid fa-floppy-disk me-2"></i>
                        Save Changes
                      </button>
                      <button
                        type="button"
                        onClick={handleCancel}
                        className="btn btn-secondary"
                        style={{
                          padding: "10px 25px",
                          fontWeight: "500",
                        }}
                      >
                        <i className="fa-solid fa-times me-2"></i>
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </section>
          ) : (
            <>
              <div className="mt-5">
                <div style={headLineStyle} className="page-headline">
                  Manage Reels
                </div>
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading reels...</p>
                  </div>
                ) : reels.length > 0 ? (
                  <div className="card">
                    <div className="card-body">
                      {/* <div className="mb-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <span className="badge bg-info">
                              Total Reels: {reels.length}
                            </span>
                          </div>
                          <div>
                            <span className="text-muted">
                              Showing {reels.length} reels
                            </span>
                          </div>
                        </div>
                      </div> */}
                      <DataTable
                        columns={columns}
                        data={reels}
                        pagination
                        responsive
                        highlightOnHover
                        striped
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[10, 20, 30, 50]}
                        noDataComponent={
                          <div className="text-center py-4">
                            <i className="fa-solid fa-video fa-2x text-muted mb-3"></i>
                            <p>No reels found</p>
                          </div>
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <div className="card">
                    <div className="card-body text-center py-5">
                      <i className="fa-solid fa-video fa-3x text-muted mb-3"></i>
                      <h5>No Reels Available</h5>
                      <p className="text-muted">
                        There are no reels to display at the moment.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Add CSS for the popup */}
      <style>
        {`
          .description-popup .swal2-popup {
            max-width: 600px;
          }
          .description-popup .swal2-html-container {
            overflow: hidden;
          }
          .rtl .btn {
            margin-left: 5px;
            margin-right: 5px;
          }
        `}
      </style>
    </>
  );
}

export default ManageReels;
